export default "__VITE_ASSET__D3AnR8Ij__"